import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { CompetitionSport } from './competition-sport'
import { CompetitionSportSerializer } from './competition-sport.serializer'

@Injectable()
export class CompetitionSportService extends ResourceService<CompetitionSport> {
  constructor(
    private http: HttpClient,
    private competitionSportSerializer: CompetitionSportSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/competition-sports`,
      competitionSportSerializer
    )
  }
}
